module.exports = __webpack_public_path__ + "img/ongle-epais.e1ec4d8f.jpg";